import React, { Component } from 'react'
import PT from 'prop-types'
import StackGrid from 'react-stack-grid'
import { Grid, Row, Col } from 'react-bootstrap'
import Post from './Post'
import withWindowSize from '../../hoc/withWindowSize'
import { imagesProp } from '../../propTypes'

const containerWidthFromWindow = (ww) => {
  // breakpoints: 1170, 970, 750
  if (ww < 750) return ww - 20
  if (ww < 970) return (970 - 40) / 2
  const maxed = ww > 1140 ? 1140 : ww
  return Math.floor((maxed - 80) / 3)
}

class PostsDesktop extends Component {
  getColWidth() {
    const { windowWidth } = this.props
    return containerWidthFromWindow(windowWidth)
  }

  render() {
    const colWidth = this.getColWidth()

    return (
      <Grid className="post-container">
        <Row>
          <Col xs={12}>
            <StackGrid
              columnWidth={colWidth}
              gutterWidth={40}
              gutterHeight={40}
              appearDelay={200}
              className="stack-grid"
            >
              {this.props.posts.map(post => (
                <Post
                  key={post._id}
                  colWidth={colWidth}
                  {...post}
                />
              ))}
            </StackGrid>
          </Col>
        </Row>
      </Grid>
    )
  }
}

PostsDesktop.propTypes = {
  posts: PT.arrayOf(PT.shape({
    _id: PT.string.isRequired,
    name: PT.string.isRequired,
    shortText: PT.string.isRequired,
    images: imagesProp,
  })).isRequired,
  windowWidth: PT.number.isRequired,
}

export default withWindowSize(PostsDesktop)



// WEBPACK FOOTER //
// ./src/components/Post/PostsDesktop.js